<section class="w3l-form-25">
  <div class="form-inner-cont">
          <h1>Booking (Reservation) Data</h1>
          <h1 style="color: rgb(78, 150, 245);text-align: center;font-weight: bolder;">  Consultation  </h1>
      </div>
</section>
<div class="w3l-form-25 wrapper ">
  <button type="button" id="Arabic" name="Arabic"  style="font-size: large;font-style: initial;font-family: Arial, Helvetica, sans-serif;width: 5%;" (click)="switchArabic()">ع </button>
  <button type="button" id="English" name="English"  style="font-size: large;font-style: initial;font-family: Arial, Helvetica, sans-serif;width: 5%;" (click)="switchEnglish()">En</button>
</div>
<div id="w3l-appointment" style="max-width: 1518px;">
<section class="appointment-section section-gap" >
  <div class="wrapper">
      <div class="d-grid doctor-appointment" >
          <div class="appointment-form">
              <form action="#" method="post">
                  <div class="fields-grid">

                    <!------- Doctors ----------->
                    <div class="styled-input">
                      <label style="width: 40%;">{{'Doctor ID' | translate }}</label>
                      <label>{{ 'Doctor Name' | translate }}</label>
                      <div class="appointment-form-field">
                          <span class="fa fa-search" aria-hidden="true" style="cursor: grab;" (click)="openDoctorDialog()" ></span>
                          <input type="text" name="doctorId" maxlength="50ch" placeholder="{{'Doctor ID' | translate }}"  maxlength="50ch" required="" style="width: 35%;" [(ngModel)]="docCode" (change)="RetriveDoctor()">
                          <input type="text" name="doctorname" placeholder="" required="" id="doctorname" [(ngModel)]="docName"  maxlength="100ch">
                        </div>
                    </div>


                    <div class="styled-input">
                      <label>{{'Date' | translate }}</label>
                          <div class="appointment-form-field">
                              <span class="fa fa-calendar" aria-hidden="true"></span>
                              <input type="date" [(ngModel)]="resDate" name="date" id="wdate" required=""  style="width: 90%;" (change)="retriveRes()">
                          </div>
                  </div>
                  <!-- <div class="styled-input">
                    <label>Room</label>
                    <div class="appointment-form-field">
                        <span class="fa fa-hotel" aria-hidden="true"></span>
                        <select id="rooms1" name="rooms1" required="" [(ngModel)]="roomCode" >
                          <option value="" >Select*</option>
                          <option value="{{unit.roomCode}}" *ngFor="let unit of roomsList; let i = index">{{unit.roomName}}</option>
                      </select>   </div>
                   </div> -->

                  <div class="styled-input">
                    <label style="width: 53%;">{{'From Time' | translate }}</label>
                    <label>{{'To Time' | translate }}</label>
                        <div class="appointment-form-field">
                          <span class="fa fa-hourglass" aria-hidden="true"></span>
                          <input type="time"  [(ngModel)]="resTime" name="time"  required="" style="width: 40%;">

                            <label>   </label>
                            <span class="fa fa-hourglass" aria-hidden="true"></span>
                            <input type="time"  [(ngModel)]="resToTime" name="time1"  required="" style="width: 40%;">

                        </div>

                </div>
                    <!------- Patient ----------->
                    <div class="styled-input">
                      <label style="width: 40%;">{{'Patient ID' | translate }}</label>
                      <label>{{'Patient Name' | translate }}</label>
                      <div class="appointment-form-field">
                          <span class="fa fa-search" aria-hidden="true" style="cursor: grab;" (click)="openDialog()" ></span>
                          <input type="text" name="patientId" maxlength="50ch" placeholder="Patient ID"  maxlength="50ch" required="" style="width: 35%;" [(ngModel)]="patientCode" (change)="RetrivePatient()" >

                          <input type="text" name="pfullname" placeholder="" required="" id="pfullname" [(ngModel)]="patientFName"  maxlength="100ch">
                        </div>
                    </div>

                         <div class="styled-input">
                      <label style="width:40% ">{{'Isurance Company' | translate }}</label>
                      <label></label>
                      <div class="appointment-form-field">

                          <button type="button" class="theme-button btn" name="submit"style="width: 40%;"  (click)="OpenDialogPatientInsurance()">Insurance rules</button>
                          <label style="width: 3%;"></label>
                          <img [hidden]= "wk_Acc_Not" src="assets/images/NoInsurance.jpg"  alt="Item Image" width="200px" height="55px" style="border: 1px;border-style: double;cursor: grab;" (click)="OpenDialogPatientInsurance()"/>
                          <img [hidden]= "wk_Acc_Not1" src="data:image/jpg;base64,{{myimage}}"  alt="Item Image" width="200px" height="55px" style="border: 1px;border-style: double;cursor: grab;" (click)="OpenDialogPatientInsurance()"/>

                        </div>
                    </div>

                      <div class="styled-input">
                          <label>{{'Reservation Type' | translate }}</label>
                          <div class="appointment-form-field">
                              <span class="	fa fa-sitemap" aria-hidden="true"></span>
                              <select id="department" required="" name="type" [(ngModel)]="resType" >
                                <option value="">Select*</option>
                                <option value="Consultation">إستشارة</option>
                                <option value="Visit">كشــف</option>
                                <option value="New Patient">مريض جديد</option>
                            </select>
                            <label style="width: 2%;"></label>
                              <span class="fa fa-street-view" aria-hidden="true"></span>
                              <select id="resonlne" required="" name="resonlne"  [(ngModel)]="resonline" >
                                <option value="On Site">On Site</option>
                                <option value="On Line">On Line</option>
                            </select>
                          </div>
                      </div>
                      <div class="styled-input">
                        <label>{{'Reservation Status' | translate }}</label>
                        <div class="appointment-form-field">
                            <span class="fa fa-street-view" aria-hidden="true"></span>
                            <select id="department" required="" name="ststus"  [(ngModel)]="resStatus" >
                              <option value="Select">Select *</option>
                              <option value="Reservation">{{'Reserved' | translate }}</option>
                              <option value="Attend">{{'Attended' | translate }}</option>
                              <option value="Now">{{'In consultat' | translate }}</option>
                              <option value="Done">{{'Done' | translate }}</option>
                              <option value="Didn't Attended">{{'Didn t Attended' | translate }}</option>
                          </select>
                        </div>


                    </div>
                      <div class="styled-input">
                        <label>{{'Mobile Number' | translate }}</label>
                        <div class="appointment-form-field">
                            <span class="fa fa-mobile" aria-hidden="true"></span>
                            <input type="text" name="mobile" placeholder="Enter Mobile" required="" [(ngModel)] ="resPhone" maxlength="50ch">
                        </div>
                    </div>

                      <div class="styled-input">
                        <label>{{'Notes' | translate }}</label>
                         <BR>
                         <BR>
                        <div class="appointment-form-field">
                          <span class="fa fa-university" aria-hidden="true" style="height: 200%;"></span>
                          <textarea rows = "5" cols = "60" name = "description" class="appointment-form-field" style="height: 200%;" [(ngModel)]="resNotes"placeholder ="Enter details here... "  maxlength="50ch"> </textarea><br>
                      </div>
                      </div>


                  </div>
              </form>
          </div>

          <div class="appointment-form">
            <div style="background-color: rgb(78, 150, 245);color: white;height: 30px;">
            <label> </label>
            <span class="fa fa-calendar" aria-hidden="true" style="padding-top: 1%; background-color: rgb(78, 150, 245);color: white;"></span>
            <label style="background-color: rgb(78, 150, 245);color: white; font-weight: bold; font-size: larger;height: 27px; font-family:Arial, Helvetica, sans-serif;"  aria-hidden="true">  {{'Calender' | translate }} </label>
            </div>
            <table>
                <thead>
                    <tr>
                        <th style="background-color:  rgb(78, 150, 245);color: white;width: 15px;">{{'S' | translate }}</th>
                        <th style="background-color:  rgb(78, 150, 245);color: white;width: 75px;">{{'Patient ID' | translate }}</th>
                        <th style="background-color:  rgb(78, 150, 245);color: white;width: 150px;">{{'Patient' | translate }}</th>
                        <th style="background-color:  rgb(78, 150, 245);color: white;width: 75px;">{{'Date' | translate }}</th>
                        <th style="background-color:  rgb(78, 150, 245);color: white;width: 80px;">{{'From Time' | translate }}</th>
                        <th style="background-color:  rgb(78, 150, 245);color: white;width: 80px;">{{'To Time' | translate }}</th>
                        <th style="background-color:  rgb(78, 150, 245);color: white;width: 60px;">{{'Reservation' | translate }}</th>
                        <th style="background-color:  rgb(78, 150, 245);color: white;width: 80px;">{{'Type' | translate }}</th>
                        <th style="background-color:  rgb(78, 150, 245);color: white;width: 30px;">{{'Status' | translate }}</th>
                        <th style="background-color:  rgb(78, 150, 245);color: white;width: 10px;">Select</th>

                      </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let res of reservationList; let i = index" [ngStyle]="{'color':  styleColor[i]}">
                      <td data-column="S">{{i + 1}}</td>
                      <td data-column="Patient ID">{{res.patientCode}}</td>
                      <td data-column="Patient Name">{{res.patientName}}</td>
                      <td data-column="Reservation Date" style="text-align: center;">{{res.resDate1}}</td>
                      <td  data-column="Reservation Time" style="text-align: center;">{{res.resTime}}</td>
                      <td data-column="To Time" style="text-align: center;">{{res.resToTime}}</td>
                      <td data-column="ResType">{{res.resType}}</td>
                      <td data-column="ResType">{{res.resonline}}</td>
                      <td data-column="Status">{{res.resStatus}}</td>
                      <td data-column="Select">  <button type="button"  name="New"  (click)="SelectReservation(res)">Select</button>
                        </td>
                    </tr>


                </tbody>

            </table>
            <div class="styled-input">
              <div class="appointment-form-field">
                <a (click)="openDialog_2()" style="cursor: grab;">► {{'Print Reservation by treatment room from date to date' | translate }}</a>

              </div>
              <div class="appointment-form-field">
              <a (click)="openDialog_1()" style="cursor: grab;">► {{'Print Reservation by Doctor from date to date' | translate }}</a>
            </div>
            <div class="appointment-form-field">
              <a (click)="openDialog_3()" style="cursor: grab;">► {{'Print Reservation by Patient from date to date' | translate }}</a>
            </div>
            </div>
          </div>

      </div>
      <div class="clear"> </div>
  </div>
  <div style="width: 100%;text-align: center;">
    <button type="button" class="theme-button btn" name="submit"style="width: 10%;"  (click)="submitReservation()">Submit</button>
   <button type="button" class="theme-button btn" name="Delete" style="width: 10%;"(click)="mesgDelete()" >Delete</button>
   <button type="button" class="theme-button btn" name="New" style="width: 10%;" (click)="NewData()">New</button>
   <a href="Home">
   <button type="button" class="theme-button btn" style="width: 10%;" name="Back">Home</button>
   </a>
 </div>
</section>
<Br>
</div>

